import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSleep: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSleep"><Path d="M3.5 8.5H8.5V9L3.5 15V15.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 2.5H16V3.25L11.5 7.75V8.5H16" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 12.5H19.5V13.1429L12.5 20.8571V21.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSleep;
